import { createContext, useContext, useEffect, useState } from 'react';
import { toSearchText } from "utils/text";

const OrderEditContext = createContext(null);

const OrderEditProvider = ({ products = [], onAddProduct, children }) => {
    const [openProductPicker, setOpenProductPicker] = useState(false);
    const [productFilter, setProductFilter] = useState({});
    const [filterProducts, setFilterProducts] = useState([]);

    useEffect(() => {
        const info = productFilter?.info;
        if (info) {
            const search = toSearchText(info);
            const list = (products ?? []).filter(x => x.product.search_text?.includes(search));
            setFilterProducts(list);
            return;
        }
        setFilterProducts([...(products ?? [])]);
    }, [productFilter, products]);

    const setProductFilterValue = (name, value) => {
        const newFilter = { ...productFilter, [name]: value };
        setProductFilter(newFilter);
    };

    return (
        <OrderEditContext.Provider value={{ openProductPicker, setOpenProductPicker, filterProducts, setProductFilterValue, onAddProduct }}>
            {children}
        </OrderEditContext.Provider>
    );
};

const useOrderEditContext = () => {
    return useContext(OrderEditContext);
};

export { OrderEditProvider, useOrderEditContext };
